import React from 'react';

import type { MentorVideos } from '../../../../types/mentor';
import { useFacePosition } from '../../hooks/useFacePosition';

interface IdleVideoLoopProps {
  hdVideo: MentorVideos | undefined;
  setIdleVideoLoaded: (loaded: boolean) => void;
}

const IdleVideoLoop: React.FC<IdleVideoLoopProps> = ({
  hdVideo,
  setIdleVideoLoaded,
}) => {
  const videoStyle = useFacePosition(hdVideo);

  const handleVideoLoad = () => {
    setIdleVideoLoaded(true);
  };

  return hdVideo?.original_video_url ? (
    <video
      loop
      autoPlay
      playsInline
      muted
      data-testid="avatar-loop-video"
      src={hdVideo?.original_video_url || ''}
      style={videoStyle}
      onLoadedData={handleVideoLoad}
    />
  ) : null;
};

export default IdleVideoLoop;
